/* @flow */
import { compose, filter, map } from 'ramda';
import { normalizeType, querystring } from 'trustar/utils';
import {Map, OrderedMap} from "immutable";

export const isReportType = (x: any) => normalizeType(x.get('type')) === 'incident_report';

export const reportIdsFromList = compose(
  map(x => x.get('id')),
  filter(isReportType),
);

export const metadataUrl = (ids: string[]) =>
  querystring({ reportId: ids })('/services/incident-reports/metadata');

// Pad strings with a given character to a given length
export const padWith = (chr: string, length: number, str: string = '') => {
  while (str.length < length) {
    str += chr;
  }
  return str;
};

export const findReportInState = (reportId: string, reports: OrderedMap<any, any>, reportList: OrderedMap<any, any>) => {
  const result = reports.getIn([reportId, 'data', 'id'])
    ? reports.getIn([reportId, 'data'], Map()) :
    reportList.getIn([reportId, 'data'], Map()) ?
      reportList.getIn([reportId, 'data'], Map()) :
      reports.getIn([reportId, 'data', 'guid'], Map());

  return result;
};



// WEBPACK FOOTER //
// ./src/app/modules/reports/utils.js